// import { ArchivedConstant as archivedConstant } from "../../constants/archivedConstant";

// const initialState = {
//   getArchivedActivityLoaderState: {
//     fetching: false,
//     fetched: false,
//     error: false
//   },
//   updateLoaderState: {
//     fetching: false,
//     fetched: false,
//     error: false
//   },
//   listOfArchivedActivities: {
//     list: [],
//     item_per_page: null,
//     page: null,
//     key: null
//   },
//   listOfArchivedProjects: {
//     list: [],
//     key: null
//   },
//   listOfArchivedChecklists: {
//     list: [],
//     key: null
//   }
// };

// export default function archivedReducer(state = initialState, action) {
//   switch (action.type) {
//     case archivedConstant.getActivity:
//       console.log(
//         "eqaul ",
//         state.listOfActivities.item_per_page === action.payload.item_per_page
//       );
//       return {
//         ...state,
//         listOfActivities: {
//           key: action.payload.key,
//           list:
//             state.listOfActivities.item_per_page ===
//             action.payload.item_per_page
//               ? [...state.listOfActivities.list, ...action.payload.activities]
//               : [...action.payload.activities],
//           item_per_page: action.payload.item_per_page,
//           page: action.payload.page
//         }
//       };
//     case archivedConstant.unarchiveActivity:
//       return {
//         ...state,
//         listOfActivities: {
//           ...state.listOfActivities,
//           list: state.listOfActivities.list.filter(
//             activity => activity.id !== action.payload.activity.id
//           )
//         }
//       };

//     case archivedConstant.updateArchiveActivityWorkFlow:
//       console.log("here");
//       return {
//         ...state,
//         listOfActivities: {
//           ...state.listOfActivities,
//           list: state.listOfActivities.list.map(activity =>
//             activity.id === action.payload.activity.id
//               ? { ...activity, workflow: action.payload.activity.workflow }
//               : activity
//           )
//         }
//       };
//     case archivedConstant.updateActivity:
//       return {
//         ...state,
//         listOfActivities: {
//           ...state.listOfActivities,
//           list: state.listOfActivities.list.map(activity =>
//             activity.id === action.payload.activity.id
//               ? { ...activity, ...action.payload.activity }
//               : activity
//           )
//         }
//       };

//     case archivedConstant.getProject:
//       return {
//         ...state,
//         listOfProjects: {
//           ...state.listOfProjects,
//           list: [...action.payload.projects]
//         }
//       };
//     case archivedConstant.unarchiveProject:
//       return {
//         ...state,
//         listOfProjects: {
//           ...state.listOfProjects,
//           list: state.listOfProjects.list.filter(
//             project => project.id !== action.payload.project.id
//           )
//         }
//       };
//     default:
//       return state;
//   }
// }
